export enum GridFooterType {
  Text,
  Sum,
}
